import SubjectService from '../../services/SubjectService'
import router from '../../router'

const state = () => ({
    subjectLoading: false,
    subject: [],
    subjects: [],
    subjectNext: [],
    // Formulário final (Google Forms) liberado ao concluir as aulas: { configurado, disciplinas: [...] }
    formularioFinal: null,
    // subjects: JSON.parse(localStorage.getItem('subjects')) || [],
    pages: JSON.parse(localStorage.getItem('pages')) || 0,
    page: JSON.parse(localStorage.getItem('page')) || 1,
})
  
const mutations = {
    SET_SUBJECT: (state, subject) => {
        state.subject = subject;
    },
    SET_SUBJECTS: (state, payload) => {
        state.subjects = payload.subjects;
    },
    SET_NEXT_SUBJECTS: (state, subject) => {
        state.subjectNext = subject;
    },
    SET_LOADING_SUBJECT: (state, payload) => {
        state.subjectLoading = payload
    },
    SET_FORMULARIO_FINAL: (state, payload) => {
        state.formularioFinal = payload
    },
    ATUALIZAR_DISCIPLINA(state, SubjectAtualizada) {
        const index = state.subjects.findIndex(d => d.id === SubjectAtualizada.id);
        
        if (index !== -1) {
          state.subjects.splice(index, 1, SubjectAtualizada);
          localStorage.setItem('subjects', JSON.stringify(state.subjects));
        }
    },
}

const actions = {
    async fetchSubject({commit}, id){
        try{
            commit('SET_LOADING_SUBJECT', true)
            const response = await SubjectService.getOne(id);
            commit('SET_SUBJECT', response.data)
            commit('SET_LOADING_SUBJECT', false)
        } catch (error) {
            commit('SET_LOADING_SUBJECT', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
        async fetchSubjects({commit}, params = {}){
        try{
            commit('SET_LOADING_SUBJECT', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' } } = params;
            const response = await SubjectService.get(keyword, pageNumber, pageSize, order);
            commit('SET_SUBJECTS', response.data)
            commit('SET_LOADING_SUBJECT', false)
        } catch (error) {
            commit('SET_LOADING_SUBJECT', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchFormularioFinal({commit}, idDisciplina = null){
        try {
            const response = await SubjectService.getFormularioFinal(idDisciplina);
            commit('SET_FORMULARIO_FINAL', response.data)
        } catch (error) {
            commit('SET_FORMULARIO_FINAL', { configurado: false, disciplinas: [] })
            if (error?.response?.status !== 401) {
                commit('SET_ALERT', {
                    heading: 'error',
                    message: error?.response?.data?.message || 'Falha ao carregar o formulário final.'
                });
            }
        }
    },
     async fetchNextSubjects({commit}){
            try{
                const response = await SubjectService.getNext();
                commit('SET_NEXT_SUBJECTS', response.data)
            } catch (error) {
                commit('LOG_USER_OUT');
                commit('SET_ALERT', {
                    heading: 'error',
                    message: error.response.data.message
                });
            }
        },
    async carregarAulasDaSubject({commit, rootState}, Subject){
        try {
            if(Subject.aulas != undefined) return
            commit('SET_LOADING_SUBJECT', true);
            const response = await SubjectService.getOne(null, Subject.id);
            const aulas = response.data.aulas
            const subject = rootState.subjects.subjects.find(d => d.id === Subject.id);

            if (subject) {
                subject.aulas = aulas;
                subject.porcentagem = response.data.porcentagem;
                commit('ATUALIZAR_DISCIPLINA', subject);
            }

            rootState.subjects.subjects.map(subject => {
                if (subject.id === Subject.id) {
                    subject.aulas = aulas;
                }
            });
            commit('SET_LOADING_SUBJECT', false);
        } catch (error) {
            commit('SET_LOADING_SUBJECT', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getSubject: state => state.subject,
    getSubjects: state => state.subjects,
    getNextSubjects: state => state.subjectNext,
    getLoadingSubject: state => state.subjectLoading,
    getFormularioFinal: state => state.formularioFinal,
}

export default {
    state,
    getters,
    mutations,
    actions
};